module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/cover-1d9a1ebf9d271998c31029d8ed6260d9.webp";